export default "__VITE_ASSET__CyTQQm0h__"